import { Navigate, useRoutes } from 'react-router-dom';

// layouts
import InspectionBookingPage from './pages/InspectionBooking/InspectionBookingPage';
import FailPage from './pages/challan/ChallanFailPage';
import ChallanPage from './pages/challan/chalanCreatePage';
import BookingPage from './pages/bookingPage';
import SuccessPage from './pages/SuccessPage';
import SimpleLayout from './layouts/simple';
//
import Page404 from './pages/Page404';
import HomePage from './pages/Home';
import SellPage from './pages/Sell';
import DreamCar from './pages/dreamCar';
import ProductSinglePage from './pages/ProductSingle';
import SingleCategory from './pages/SingleCategory';
import AllProducts from './pages/AllProducts';
import VehicleSearch from './pages/search';
import ChallanSuccessPage from './pages/challan/ChallanSuccessPage';
import InspectionPage from './pages/Inspection/index';
import UsedCarInspectionPage from './pages/UsedCarInspection/index';
import VerifyPage from './pages/verify';
import PdfViewPage from './pages/pdfViewer';
import InspectionBookingFormPage from './pages/InspectionBooking/InspectionBookingFormPage';
import PayLaterSuccessPage from './pages/InspectionBooking/payLaterSuccessPage';
import PayLaterFailPage from './pages/InspectionBooking/payLaterFailPage';
import PaymentSuccessPage from './pages/InspectionBooking/paymentSuccessPage';
import PaymentFailPage from './pages/InspectionBooking/paymentFailPage';
// ----------------------------------------------------------------------

export default function Router() {
  const routesList = [
    // public
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/home" />, index: true },
        {
          path: '/',
          children: [
            {
              path: 'home',
              element: <HomePage />,
            },
            {
              path: 'allproducts',
              element: <AllProducts />,
            },
            {
              path: 'sell',
              element: <SellPage />,
            },
            {
              path: 'dream',
              element: <DreamCar />,
            },
            {
              path: 'product-single/:id',
              element: <ProductSinglePage />,
            },
            {
              path: 'category-single/:id',
              element: <SingleCategory />,
            },
            {
              path: 'search',
              element: <VehicleSearch />,
            },
            {
              path: 'success-page',
              element: <SuccessPage />,
            },
            {
              path: 'challan-success-page/:id',
              element: <ChallanSuccessPage />,
            },
            {
              path: 'challan-fail-page',
              element: <FailPage />,
            },
            {
              path: 'booking/:id',
              element: <BookingPage />,
            },
            {
              path: 'inspection-booking',
              element: <InspectionBookingPage />,
            },
            {
              path: 'booking',
              element: <InspectionBookingFormPage />,
            },
            {
              path: 'pay-latter-success/:id',
              element: <PayLaterSuccessPage />,
            },
            {
              path: 'pay-latter-fail',
              element: <PayLaterFailPage />,
            },
            {
              path: 'payment-success/:id',
              element: <PaymentSuccessPage />,
            },
            {
              path: 'payment-fail/:id',
              element: <PaymentFailPage />,
            },
            {
              path: 'challan',
              element: <ChallanPage />,
            },
            {
              path: 'inspection',
              element: <InspectionPage />,
            },
            {
              path: 'used-car-inspection-kerala',
              element: <UsedCarInspectionPage />,
            },
            {
              path: 'verify',
              element: <VerifyPage />,
            },
            {
              path: '/pdf-view/:id',
              element: <PdfViewPage />,
            },

            // add other routes here
          ],
        },

        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },

    // handle notfound routes
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ];

  const routes = useRoutes(routesList);

  return routes;
}
